<template>
  <span class="ag-grid-text">{{ agValue }}</span>
</template>

<script>

import agEditorMixins from './ag-editor-mixins'

export default {
  name: 'AgGridText',
  mixins: [agEditorMixins],
  props: {
  },
  data() {
    return {}
  },
  methods: {

  }
}
</script>

